import { render } from "./FahrzeugVerwaltung.vue?vue&type=template&id=67089a8c"
import script from "./FahrzeugVerwaltung.vue?vue&type=script&lang=js"
export * from "./FahrzeugVerwaltung.vue?vue&type=script&lang=js"

import "./FahrzeugVerwaltung.vue?vue&type=style&index=0&id=67089a8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__